<template>
  <div class="cusbtn2" @click="btnClick">
    <!-- 这个继续新增 不直接调用 原生文件夹 -->
    <span>{{value}}</span>
  </div>
</template>
<script>
export default {
  name: "cusBtn2",
  props: {
    value: {
      type: String,
      default: () => {
        return "继续新增";
      }
    }
  },
  data() {
    return {};
  },
  methods: {
    btnClick() {
      this.$emit("click");
    }
  }
};
</script>
<style lang="less" scoped>
.cusbtn2 {
  width: 100%;
  height: 40px;
  background: rgba(255, 255, 255, 1);
  border-radius: 3px;
  border: 1px solid rgba(54, 179, 116, 1);
  line-height: 40px;
  text-align: center;
  span {
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(54, 179, 116, 1);
  }
}
</style>